import { EventFilter, Event } from "./EventModel";
import { Pagination } from "../Common/CommonModel";

export const GET_EVENT_LIST_START = "GET_EVENT_LIST_START";
export const GET_EVENT_LIST_COMPLETED = "GET_EVENT_LIST_COMPLETED";
export const GET_EVENT_LIST_FAILED = "GET_EVENT_LIST_FAILED";
export const GET_EVENT_ITEM_START = "GET_EVENT_ITEM_START";
export const GET_EVENT_ITEM_COMPLETED = "GET_EVENT_ITEM_COMPLETED";
export const SET_DETAILED_EVENT = "SET_DETAILED_EVENT";

export type EventActionTypes =
  | { type: typeof GET_EVENT_LIST_START; payload: { filter: EventFilter } }
  | { type: typeof GET_EVENT_LIST_COMPLETED; payload: { items: Event[]; pagination: Pagination } }
  | { type: typeof GET_EVENT_LIST_FAILED }
  | { type: typeof GET_EVENT_ITEM_START; payload: number }
  | { type: typeof GET_EVENT_ITEM_COMPLETED; payload: Event }
  | { type: typeof SET_DETAILED_EVENT; payload: Event };